import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@material-ui/core';
import {
  Avatar,
  Flex,
  Icon,
  IconButton,
  Progress,
  Typography,
} from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../../knock-design-system';
import { convertBytesToKB } from './utils';
import { IMPORT_STATUS, IMPORT_STATUS_LABEL } from './constants';

export const HIDDEN_INPUT_LABEL = 'file-input';

const useCss = makeCss({
  uploadCard: {
    height: '80px',
    marginTop: '16px',
    border: '1px solid #E2E3E9',
  },
  uploadCardContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

export const PropertiesImportStatus = ({
  fileName,
  fileSize,
  importStatus,
  removeUploadedFile,
}) => {
  const css = useCss();

  return (
    <Card css={css.uploadCard} variant="outlined">
      <CardContent css={css.uploadCardContent}>
        <Flex alignItems="center" gap={16}>
          <Avatar size={40} color="primary.200" variant="circular">
            <Icon size={24} name="document" color="secondary.700" />
          </Avatar>
          <Flex flexDirection="column" gap={4}>
            <Typography variant="subtitle1">{fileName}</Typography>

            <Flex alignItems="center" gap={6}>
              <Typography variant="body2">{`${convertBytesToKB(
                fileSize
              )}kb`}</Typography>

              <Typography variant="body2">·</Typography>
              <Typography variant="body2">
                {IMPORT_STATUS_LABEL[importStatus]}
              </Typography>
            </Flex>
          </Flex>
        </Flex>

        <Flex gap={10} alignItems="center">
          <IconButton
            iconName="close-md"
            iconSize="medium"
            size="medium"
            onClick={removeUploadedFile}
          />
          {importStatus === IMPORT_STATUS.PROCESSING && (
            <Progress type="circular" />
          )}
          {importStatus === IMPORT_STATUS.SUCCESS && (
            <Avatar color="success.500" variant="circular">
              <Icon name="check-circle-filled" />
            </Avatar>
          )}
        </Flex>
      </CardContent>
    </Card>
  );
};

PropertiesImportStatus.propTypes = {
  fileName: PropTypes.string,
  fileSize: PropTypes.number,
  importStatus: PropTypes.oneOf([
    IMPORT_STATUS.IDLE,
    IMPORT_STATUS.PROCESSING,
    IMPORT_STATUS.READY,
    IMPORT_STATUS.SUCCESS,
    IMPORT_STATUS.ERROR,
  ]),
  removeUploadedFile: PropTypes.func,
};
